export * from './resources/delegate';
export * from './resources/plugin';
export * from './resources/template';
export * from './resources/process';
export * from './resources/view';

export * from './core/resource';
export * from './core/service';

export * from './controllers/ignition';
export * from './controllers/kernel';

import { Process } from './resources/process';
import { View } from './resources/view';

import { Ignition } from './controllers/ignition';
import { Kernel } from './controllers/kernel';

import { Service } from './core/service';

export default {
  Ignition,
  Kernel,

  Service,

  Process,
  View
};
